export default {
  img: {
    width: '150px',
    height: '150px',
    margin: '10px 0 30px'
  }
}
